export default "__VITE_ASSET__f997f9fa__"